import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=ff58a4b4&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=ff58a4b4&prod&lang=scss&scoped=true"
import style1 from "./Modal.vue?vue&type=style&index=1&id=ff58a4b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff58a4b4",
  null
  
)

export default component.exports